import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { BENEFICIOS } from '../../data/content';
export function ProductIntro() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-227" data-mp="21i2s0g285ifw">
      <div className="max-w-5xl mx-auto rounded-3xl bg-crema-alt border border-dorado/25 p-7 sm:p-12" data-id="element-228" data-mp="2fgj12dnk7l17">
        <div className="text-center max-w-3xl mx-auto" data-id="element-229" data-mp="2agn4gzh6yvvo">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-230" data-mp="2aj9c0z431bdw">
            Por eso armamos un entrenamiento, no otro cuadernillo de planas
          </h2>
          <p className="mt-4 text-lg sm:text-xl text-tinta/80 leading-relaxed" data-id="element-231" data-mp="2keuain9xztiw">
            6 tomos en orden, de lo más simple a lo más difícil, con un plan de 21 días que te dice
            qué hacer y qué mirar cada día.
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-232" data-mp="383vm2je2nkse">
          {BENEFICIOS.map((beneficio, i) => <li key={beneficio} className={`flex items-start gap-4 rounded-2xl bg-white p-5 shadow-sm ${i === BENEFICIOS.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-233" data-mp="336dccqs8d1jc" data-mpi={i}>
              <CheckCircle2Icon className="w-6 h-6 text-coral shrink-0 mt-0.5" aria-hidden="true" data-id="element-234" data-mp="2l4qj6ibv30h9" />
              <p className="text-base sm:text-lg leading-snug text-tinta" data-id="element-235" data-mp="2q29wng0qj985">{beneficio}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}